import * as S from './layout';
import LoadingSmall from './Small';

// Plus d'explication sur l'utilisation de data-placeholder dans
// le fichier `src/common/components/Category/Menu/MenuLoading.tsx`
const items = {
  'Poma Rubra Recentia': 9,
  'Citrus Magna atque Limonia Flava': 14,
  'Baccha Nigrae aut Uvae Albae Madurae': 7,
  'Ficus Mellita ac Dactyli Teneri': 16,
  'Pruna Sucrosa atque Persica Florida': 11,
};

const LoadingLarge = () => (
  <S.LoadingLargeContainer>
    <S.LoadingLargeTitle data-placeholder="Fructus Dulces atque Acri Temporarii" />
    {Object.entries(items).map(([title, count]) => (
      <S.LoadingLargeSection key={title}>
        <S.LoadingLargeSubTitle data-placeholder={title} />
        <LoadingSmall count={count} />
      </S.LoadingLargeSection>
    ))}
  </S.LoadingLargeContainer>
);

export default LoadingLarge;
